exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_04b46f8{width:250px!important}.inputW2_756db22{width:295px!important;display:inline-block!important;margin-right:10px}.tipWord_297fb2d{margin:0 10px}.tip_742b47e{color:red;margin-top:4px}.textarea_f7172c7{width:320px!important;height:100px}.textarea_f7172c7 .k-textarea{height:100px!important;resize:none}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_04b46f8",
	"inputW2": "inputW2_756db22",
	"tipWord": "tipWord_297fb2d",
	"tip": "tip_742b47e",
	"textarea": "textarea_f7172c7"
};